<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">{{title}}</h1>
        </div>
    </div>
</nav>

<div class="flex-1">
    <p-messages [severity]="severity">
        <ng-template pTemplate>
            <span class="message">{{message}}</span>
        </ng-template>
    </p-messages>
    <br/>

    <div class="text-align-center w-full">
        <h1>{{description}}</h1>
    </div>
    <p-button *ngIf="downloadButtonVisible" [loading]="loading" label="Pobierz wysłany wniosek" icon="pi pi-download" iconPos="left" class="justify-content-center flex" (click)="downloadProposal()"></p-button>
</div>
<br/>
<div class="flex">
    <p-button label="Wybór wniosku" icon="pi pi-backward" iconPos="left" styleClass="ml" (click)="chooseForm()"></p-button>
</div>




